import { createApp, defineComponent } from "vue";
import { GoogleMap, Marker, InfoWindow } from "vue3-google-map";

const WARNING_MAX_DISTANCE_KM = 40;
const MAX_DISTANCE_KM = 80;
const MAX_RESULTS = 15;

const getDistanceFromLatLonInKm = (
  lat1: number,
  lon1: number,
  lat2: number,
  lon2: number
) => {
  var R = 6371; // Radius of the earth in km
  var dLat = deg2rad(lat2 - lat1); // deg2rad below
  var dLon = deg2rad(lon2 - lon1);
  var a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) *
      Math.cos(deg2rad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c; // Distance in km
  return d;
};

const deg2rad = (deg: number) => {
  return deg * (Math.PI / 180);
};

const initStockists = () => {
  const GOOGLE_PUBLIC_KEY = "AIzaSyBRxHQJ9-W9VaKO-axsaDILmiw4kVuxoc0";

  const componentDefinition = defineComponent({
    methods: {
      onSubmit() {
        // if the text is a lat/long, use that
        const regexExp =
          /^((\-?|\+?)?\d+(\.\d+)?),\s*((\-?|\+?)?\d+(\.\d+)?)$/gi;

        if (this.location && regexExp.test(this.location)) {
          this.lat = this.location.split(",")[0];
          this.lng = this.location.split(",")[1];

          // geocode the lat/long to get the country
          const updateUrl =
            "https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
            this.lat +
            "," +
            this.lng +
            "&sensor=false&key=" +
            "AIzaSyCFODeRlkQpXi6x_78NFbRpym1XwrVpa9w";

          fetch(updateUrl)
            .then((response) => {
              return response.json();
            })
            .then((data) => {
              this.country = data.results[0].address_components
                .find((component) => {
                  return component.types.includes("country");
                })
                .short_name.toUpperCase();

              this.isInAu = this.country == "AU";
              this.isInNz = this.country == "NZ";

              this.triggerSearch(true);
            });
        }
      },
      generateFilteredStockists(rebounds = false) {
        if (typeof window.stockists === "undefined") {
          return;
        }

        const addressLat = this.lat;
        const addressLng = this.lng;

        const bounds = new google.maps.LatLngBounds();
        let isInRange = false;

        const stockistsWithDistances = window.stockists.map((stockist) => {
          const distance = getDistanceFromLatLonInKm(
            addressLat,
            addressLng,
            stockist.lat,
            stockist.lng
          );

          stockist.distance = distance;

          if (distance < WARNING_MAX_DISTANCE_KM) {
            isInRange = true;
          }

          return stockist;
        });

        const filtered = stockistsWithDistances.filter((stockist) => {
          return stockist.distance > 0 && stockist.distance <= MAX_DISTANCE_KM;
        });

        this.hasStockistInRange = isInRange;
        console.log(this.filterByName, "WILL FILTER BY NAME");

        this.filteredStockists = filtered
          .sort((a, b) => {
            return a.distance - b.distance;
          })
          .filter((stockist) => {
            return this.filterByName
              ? stockist.name
                  .toLowerCase()
                  .includes(this.filterByName.toLowerCase())
              : true;
          })
          .splice(0, MAX_RESULTS);

        this.filteredStockists.forEach((stockist) => {
          bounds.extend({
            lat: stockist.lat,
            lng: stockist.lng,
          });
        });

        this.loading = false;

        if (this.googleMap) {
          if (rebounds) {
            if (this.filteredStockists.length > 0) {
              this.googleMap.fitBounds(bounds);
            }
            this.triggerMove = false;
            this.googleMap.setCenter(
              new google.maps.LatLng(addressLat, addressLng)
            );
          }
        }
      },
      triggerSearch(rebounds = true) {
        this.loading = true;
        this.generateFilteredStockists(rebounds);

        const url = new URL(window.location);
        url.searchParams.set("location", this.lat + "," + this.lng);

        window.history.pushState({}, "", url);
      },
      getDirections(e) {
        return `https://www.google.com/maps/dir/?api=1&destination=${e.lat},${e.lng}`;
      },
      getTel(phone) {
        return `tel:${phone.replaceAll(" ", "")}`;
      },
      getDistance(stockist) {
        const distance = stockist.distance.toFixed(1);

        return `${distance}km`;
      },
      getHours(stockist) {
        let day = new Date().getDay() - 1;
        if (day == -1) {
          day = 6;
        }

        if (typeof stockist.opening_hours[day] !== "undefined") {
          const text = stockist.opening_hours[day];

          if (text.indexOf("Closed") > -1) {
            return "Closed";
          } else {
            let closes = text.split(" â€“ ")[1];
            console.log(closes);
            if (!closes) {
              return '<span class="text-green">Open</span>';
            }

            return '<span class="text-green">Open</span> - Closes ' + closes;
          }
        }

        return "";
      },
      getPosition(stockist) {
        return {
          lat: stockist.lat,
          lng: stockist.lng,
        };
      },
      toggleInfoWindow: function (stockist, idx) {
        const stockistEl = document.querySelector(
          '.stockist[data-id="' + idx + '"]'
        );

        this.infoOptions = {
          ...this.infoOptions,
          position: { lat: stockist.lat, lng: stockist.lng },
          content: stockistEl ? stockistEl.innerHTML : "",
        };

        if (this.currentMidx == idx) {
          this.infoWinOpen = !this.infoWinOpen;
        } else {
          this.infoWinOpen = true;
          this.currentMidx = idx;
        }
      },
      useCurrentLocation(e) {
        e.preventDefault();

        try {
          this.loading = true;

          const options = {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0,
          };

          this.location = "My location";

          const success = (pos) => {
            this.lat = pos.coords.latitude;
            this.lng = pos.coords.longitude;

            this.triggerSearch(true);
          };

          navigator.geolocation.getCurrentPosition(
            success,
            (err) => {
              console.warn(`ERROR(${err.code}): ${err.message}`);

              this.loading = false;
            },
            options
          );
        } catch (e) {
          console.error(e);
        }
      },
      getMarkerOptions(stockist) {
        return {
          position: { lat: stockist.lat, lng: stockist.lng },
          icon: this.pinIcon || undefined,
          clickable: true,
        };
      },
      onMapReady(map) {
        this.googleMap = map;

        const provided = new URLSearchParams(window.location.search).get(
          "location"
        );

        if (provided) {
          this.onSubmit();
        } else {
          this.generateFilteredStockists(true);
        }

        const self = this;

        google.maps.event.addListener(map, "idle", function () {
          if (
            !this.get("dragging") &&
            this.get("oldCenter") &&
            this.get("oldCenter") !== this.getCenter()
          ) {
            self.lat = this.getCenter().lat();
            self.lng = this.getCenter().lng();

            self.triggerSearch(false);
          }

          if (!this.get("dragging")) {
            this.set("oldCenter", this.getCenter());
          }
        });

        google.maps.event.addListener(map, "dragstart", function () {
          this.set("dragging", true);
        });

        google.maps.event.addListener(map, "dragend", function () {
          this.set("dragging", false);

          google.maps.event.trigger(this, "idle", {});
        });

        const autocomplete = new google.maps.places.Autocomplete(
          document.querySelector("#autocomplete")
        );

        autocomplete.addListener("place_changed", function () {
          self.loading = true;

          const place = autocomplete.getPlace();

          if (place && place.geometry) {
            self.lat = place.geometry.location.lat();
            self.lng = place.geometry.location.lng();
            self.location = place.formatted_address;
            self.country = place.address_components
              .find((component) => {
                return component.types.includes("country");
              })
              .short_name.toUpperCase();

            self.isInAu = self.country == "AU";
            self.isInNz = self.country == "NZ";
            self.triggerSearch(true);
          }
        });
      },
    },
    mounted() {
      // vue3-google-map loads the Google Maps script itself and exposes a
      // `ready` flag plus the `map`/`api` instances on the component ref.
      // Wait for `ready` before wiring up the map (replaces vue2-google-maps'
      // `$mapPromise`).
      const waitForMap = () => {
        const mapComponent: any = this.$refs.mapRef;

        if (!mapComponent || !mapComponent.ready) {
          window.setTimeout(waitForMap, 50);
          return;
        }

        this.onMapReady(mapComponent.map);
      };

      waitForMap();
    },
    data() {
      return {
        stockists: window.stockists,
        filteredStockists: [],
        hasStockistInRange: true,
        loading: true,
        isInNz: window.MAP_COUNTRY == "nz",
        isInAu: window.MAP_COUNTRY == "au",
        country: window.MAP_COUNTRY ?? "nz",
        filterByName: window.FILTER_BY_NAME ?? false,
        lat: window.MAP_LAT ?? -36.8508827,
        lng: window.MAP_LNG ?? 174.7644881,
        googleMap: null,
        triggerMove: true,
        apiKey: GOOGLE_PUBLIC_KEY,
        pinIcon: window.MAP_PIN_ICON ?? "",
        location:
          new URLSearchParams(window.location.search).get("location") ?? "",
        mapCenter: {
          lat: window.MAP_LAT ?? -36.8508827,
          lng: window.MAP_LNG ?? 174.7644881,
        },
        infoWinOpen: false,
        currentMidx: null,

        infoOptions: {
          content: "",
          position: null,
          maxWidth: 300,
        },
        mapOptions: {
          zoomControl: true,
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: false,
          gestureHandling: "cooperative",
          fullscreenControl: true,
          minZoom: 7,
          zoom: 14,
          disableDefaultUi: false,
          styles: [
            {
              featureType: "water",
              elementType: "geometry",
              stylers: [{ color: "#e9e9e9" }, { lightness: 17 }],
            },
            {
              featureType: "landscape",
              elementType: "geometry",
              stylers: [{ color: "#f5f5f5" }, { lightness: 20 }],
            },
            {
              featureType: "road.highway",
              elementType: "geometry.fill",
              stylers: [{ color: "#ffffff" }, { lightness: 17 }],
            },
            {
              featureType: "road.highway",
              elementType: "geometry.stroke",
              stylers: [
                { color: "#ffffff" },
                { lightness: 29 },
                { weight: 0.2 },
              ],
            },
            {
              featureType: "road.arterial",
              elementType: "geometry",
              stylers: [{ color: "#ffffff" }, { lightness: 18 }],
            },
            {
              featureType: "road.local",
              elementType: "geometry",
              stylers: [{ color: "#ffffff" }, { lightness: 16 }],
            },
            {
              featureType: "poi",
              elementType: "geometry",
              stylers: [{ color: "#f5f5f5" }, { lightness: 21 }],
            },
            {
              featureType: "poi.park",
              elementType: "geometry",
              stylers: [{ color: "#dedede" }, { lightness: 21 }],
            },
            {
              elementType: "labels.text.stroke",
              stylers: [
                { visibility: "on" },
                { color: "#ffffff" },
                { lightness: 16 },
              ],
            },
            {
              elementType: "labels.text.fill",
              stylers: [
                { saturation: 36 },
                { color: "#333333" },
                { lightness: 40 },
              ],
            },
            {
              elementType: "labels.icon",
              stylers: [{ visibility: "off" }],
            },
            {
              featureType: "transit",
              elementType: "geometry",
              stylers: [{ color: "#f2f2f2" }, { lightness: 19 }],
            },
            {
              featureType: "administrative",
              elementType: "geometry.fill",
              stylers: [{ color: "#fefefe" }, { lightness: 20 }],
            },
            {
              featureType: "administrative",
              elementType: "geometry.stroke",
              stylers: [
                { color: "#fefefe" },
                { lightness: 17 },
                { weight: 1.2 },
              ],
            },
          ],
        },
      };
    },
  });

  const instanceApp = createApp(componentDefinition as any);
  // Register vue3-google-map components under the tag names used in the
  // in-DOM template (kebab-case is required for in-DOM templates).
  instanceApp.component("gmap-map", GoogleMap);
  instanceApp.component("gmap-marker", Marker);
  instanceApp.component("gmap-info-window", InfoWindow);
  instanceApp.mount("#stockists");
};

export default initStockists;
